import { Injectable } from '@angular/core';
import {
    FilterResult,
    RepositoryService,
} from '../../../helpers/crud/repository.service';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { environment } from '../../../../environments/environment';
import { InputFilter, ScreenForList, ScreenMap } from '../model/store.model';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root',
})
export class ScreenService extends RepositoryService<ScreenForList> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'screen');
    }

    /**
     *
     * @returns Liste des écrans simplifié pour la map
     */
    getScreensMap(endDate?: string, startDate?: string) {
        let newInput = new InputFilter();
        if (endDate && startDate) {
            newInput.sd = startDate;
            newInput.ed = endDate;
        }

        return this.http.post<ScreenMap[]>(
            `${this.url}/Maps`,
            endDate ? newInput : {},
            environment.apiBaseStore
        );
    }

    /**
     *
     * @param screenId Id de l'écran
     * @param userLat Latitude
     * @param userLng Longitude
     * @returns L'écran correspondant
     */
    getScreenInfo(
        screenId: number,
        userLat?: number,
        userLng?: number,
        campaignDates?: { startDate?: any; endDate?: any }
    ) {
        let newInput = new InputFilter();
        if (userLat != null && userLng != null) {
            newInput.la = userLat;
            newInput.lo = userLng;
        }

        if (DateTime.isDateTime(campaignDates.startDate)) {
            newInput.sd = campaignDates.startDate.toISODate();
        } else {
            newInput.sd = DateTime.fromJSDate(
                campaignDates.startDate
            ).toISODate();
        }

        if (DateTime.isDateTime(campaignDates.endDate)) {
            newInput.ed = campaignDates.endDate.toISODate();
        } else {
            newInput.ed = DateTime.fromJSDate(
                campaignDates.endDate
            ).toISODate();
        }

        return this.http.post<ScreenForList>(
            `${this.url}/${screenId}`,
            newInput,
            environment.apiBaseStore
        );
    }

    /**
     *
     * @param userLat *nullable* Latitude de recherche
     * @param userLng *nullable* Longitude de recherche
     * @param fAs *nullable* tableau de faceIds
     * @param filterParams *nullable*
     * @param campaignDates *nullable* dates de la campagne
     * @returns La liste des écrans
     */
    getScreenList(
        userLat?,
        userLng?,
        fAs?: number[],
        filterParams?: InputFilter,
        campaignDates?: { startDate?: any; endDate?: DateTime }
    ) {
        let newInput = new InputFilter();
        if (userLat != null && userLng != null) {
            newInput.la = userLat;
            newInput.lo = userLng;
        }

        if (DateTime.isDateTime(campaignDates.startDate)) {
            newInput.sd = campaignDates.startDate.toISODate();
        } else {
            newInput.sd = DateTime.fromJSDate(
                campaignDates.startDate
            ).toISODate();
        }

        if (DateTime.isDateTime(campaignDates.endDate)) {
            newInput.ed = campaignDates.endDate.toISODate();
        } else {
            newInput.ed = DateTime.fromJSDate(
                campaignDates.endDate
            ).toISODate();
        }

        if (filterParams) {
            newInput.page = filterParams.page;
            newInput.pageSize = filterParams.pageSize;
            newInput.ONC = filterParams.ONC;
        }

        if (fAs != null) {
            newInput.fAs = fAs;
        }
        return this.http.post<FilterResult<ScreenForList>>(
            `${this.url}`,
            newInput,
            environment.apiBaseStore
        );
    }

    /**
     *
     * @param faceIds Faces sélectionnées
     * @param campaignDates Dates de la campagnes
     * @returns `boolean` true si warning a lever
     */
    checkScreenSelection(
        faceIds: number[],
        campaignDates?: { startDate?: DateTime; endDate?: DateTime }
    ) {
        let input: InputFilter = new InputFilter();
        if (DateTime.isDateTime(campaignDates.startDate)) {
            input.sd = campaignDates.startDate.toISODate();
        } else {
            input.sd = DateTime.fromJSDate(campaignDates.startDate).toISODate();
        }

        if (DateTime.isDateTime(campaignDates.endDate)) {
            input.ed = campaignDates.endDate.toISODate();
        } else {
            input.ed = DateTime.fromJSDate(campaignDates.endDate).toISODate();
        }

        input.fAs = faceIds;

        return this.http.post<boolean>(
            `${this.url}/checkForWarning`,
            input,
            environment.apiBaseStore
        );
    }

    getSize(faceIds: number[]) {
        let input: InputFilter = new InputFilter();
        input.fAs = faceIds;
        return this.http.post<boolean>(
            `${this.url}/getSize`,
            input,
            environment.apiBaseStore
        );
    }

    public getAspectRatio(pixelWidth: number, pixelHeight: number): string {
        const gcd = (a: number, b: number): number => {
            return b === 0 ? a : gcd(b, a % b);
        };
        const divisor = gcd(pixelWidth, pixelHeight);
        const widthRatio = pixelWidth / divisor;
        const heightRatio = pixelHeight / divisor;
        return `${widthRatio}:${heightRatio}`;
    }
}
